import {useHistory, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Button} from "react-bootstrap";
import {Icon} from "../components";
import React from "react";

const FormButton = React.forwardRef(({"new": newButton, edit, cancel, submit, state, ...props}, ref) => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();

  const handleAction = (action) => {
    let pathOptions = {
      pathname:`${location.pathname}/${action}`
    }
    if (state) {
      pathOptions = {
        ...pathOptions,
        state
      }
    }
    return () => history.push(pathOptions)
  }

  if (edit) {
    return (
      <Button variant="primary" onClick={props.onClick || handleAction("edit")} {...props}>
        <Icon icon='edit' text={t("edit")} />
      </Button>
    )
  } else if (newButton) {
    return (
      <Button variant="primary" onClick={handleAction("new")} {...props}>
        <Icon icon='plus' text={t("new")} />
      </Button>
    )
  } else if (cancel) {
    return (
      <Button variant='secondary' {...props}>
        <Icon icon='cancel' text={t("cancel")} />
      </Button>
    )
  } else if (submit) {
    return (
      <Button type="submit" variant="primary" {...props}>
        <Icon icon='save' text={t("save")} />
      </Button>
    )
  }
});

export default FormButton
